// import "@babel/polyfill"
import Vue from 'vue'
import global_mixin from '../global_mixins.js'
import LazyBackground from '../../components/LazyBackground.vue'
import '../../css/commercial/commercial_detail.css'
var _ = require('lodash')
import gql from 'graphql-tag'
import VueGallery from '../../components/Gallery.vue'
/*var lightGallery = require('lightgallery.js')*/
import 'lightgallery.js'
import 'lightgallery.js/dist/css/lightgallery.css'
import 'lg-video.js'
import { Base64 } from 'js-base64'
import CommercialContactForm from '../../components/CommercialContactForm.vue'
import LogoCarousel from '../../components/LogoCarousel.vue'
Vue.component('lazy-background', LazyBackground)

const app = new Vue({
  el: '#app',
  components: {
    'gallery': VueGallery,
    'commercial-contact-form': CommercialContactForm,
    'logo-carousel': LogoCarousel
  },
  mixins: [global_mixin],
  data() {
    return {
      featuredScene: {},
      scenes: []
    }
  },
  apollo: {
    currentCommercialScenes: {
      query: gql `query CommercialSpace($id: ID!) {
  commercialSpace(id: $id) {
    category
    description
    descriptionHeadline
    seoTitle
    seoDescription
    scenes{
      edges{
        node{
          seoDescription
          seriesInImage
          colorsInImage
          shapesInImage
          featuredImage
          originalImage
          sliderImage
          brandName
        }
      }
    }
    __typename
  }
}`,
      update: data => data.commercialSpace,
      error(error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        }
        else {
          console.error(error)
        }
      },
      variables() {
        return {
          id: Base64.encode(`CommercialSpaceGraph:${JSON.parse(document.getElementById('commercialSceneId').textContent)}`)
        }
        
      },
      skip() {
        return false
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
      result(data) {
        let sceneList = data.data.commercialSpace.scenes.edges.map((scene) => {
          scene.node.seriesInImage = JSON.parse(JSON.parse(scene.node.seriesInImage))
          return scene
        })
        this.scenes = _.filter(sceneList, function(o){
          return o.node.featuredImage == false
        })
        this.featuredScene = _.find(sceneList, function(o){
          return o.node.featuredImage
        })
        // let slides = []
        // if(data.data.allCommercialSpaces != ''){
        //   for(const space of data.data.allCommercialSpaces.edges){
        //     slides.push({
        //       image: space.node.featuredImage,
        //       category: space.node.category,
        //       location: space.node.scenes.edges[0].node.location,
        //       colorsInImage: space.node.scenes.edges[0].node.colorsInImage,
        //       seriesInImage: space.node.scenes.edges[0].node.seriesInImage,
        //       shapesInImage: space.node.scenes.edges[0].node.shapesInImage,
        //       tagline: space.node.scenes.edges[0].node.tagline
        //     })
        //   }
        // }
        // this.slides = slides
        // this.$nextTick(async function () {
        //   await this.updateMainSlider()
        // });
        
        // let slides = []
        // console.log(data)
        // if (data.data.allCommercialSpaces.edges[0].node.series.videoEmbedUrl != '') {
        //   let href = data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl
        //   let youtubeID = href.split("embed/")
        //   slides.push({
        //     href: data.data.allRoomScenes.edges[0].node.series.videoEmbedUrl,
        //     thumbnail: 'https://img.youtube.com/vi/'+youtubeID[1]+'/default.jpg',
        //     id: 'dsafdsfdsafdfdfrfafafadfsf'
        //   })
        // }
        // for (const scene of data.data.allRoomScenes.edges) {
        //   slides.push(scene.node)
        // }
        // this.currentSeriesPolaroids = slides
      }
    }
  },
  mounted() {},
  methods: {},
  computed: {},
  watch: {},
});



// WEBPACK FOOTER //
// ./core/vue/js/commercial/commercial_detail.js